


import TiwiMixin from '../mixins/TiwiMixin';
import ContentCard from './ContentCard';

export default {
  mixins: [TiwiMixin],
  components: {
    ContentCard,
  },
  props: {
    /* posts: {
      required: true,
      type: Array,
    },*/
  },
  data() {
    return {
      posts: [],
      pt_count: {},
      selected_pt: []
    }
  },
  mounted: function () {
    // this.getBookmarks();
    this.selected_pt = [];
  },
  computed: {
    selectedPostTypes: function () {
      if (this.selected_pt.length == 0) {
        return Object.keys(this.post_types);
      }
      return this.selected_pt;
    }
  },
  methods: {
    getBookmarks: function () {
      const self = this;
      const saved_posts = this.user_activity?.SAVE.post;

      var post_data = {
        posts_per_page: 100,
        paged: -1,
        post_type: this.selectedPostTypes,
        post_in: saved_posts
      };

      this.api.post('posts', post_data)
        .then((response) => {
          if (response.data.success) {
            self.posts = response.data.posts;

            if (this.selected_pt.length == 0) {
              self.posts?.forEach(post => {
                self.pt_count[post.type] = (self.pt_count?.[post.type] || 0) + 1;
              })
            }
          } else {
            self.toast.error(response.data.message);
          }

        })
        .catch((error) => {
          self.toast.error('Errore nella richiesta');
        })
    },
    togglePostType: function (pt) {
      if (this.selected_pt.includes(pt)) {
        this.selected_pt.splice(this.selected_pt.indexOf(pt), 1);
      } else {
        this.selected_pt.push(pt);
      }

      this.getBookmarks();
    },
    hasPosts: function(type) {
      return this.pt_count?.[type] || 0;
    }
  },
  watch: {
    user_activity: function (activities) {
      if (activities) {
        this.getBookmarks();
      }
    },
  }
}
